import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {GenericDocARAPContainerModel} from '../../../../../../models/aggregates/generic_doc';
import { ApiVisa, BasicApiResponseModel } from '../../shared';

@Injectable({providedIn: 'root'})

export class ARAPService extends BaseApiTemplateService<GenericDocARAPContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = `${Core2Config.DOMAIN_URL}${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}gen-doc/arap-contras/backoffice-ep`
    this.endpoint_path = `${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}gen-doc/arap-contras/backoffice-ep`;
    this.httpClient = http;
  }

  public updateContraTxnDate(container: GenericDocARAPContainerModel, visa: ApiVisa) {
    const url = this.apiUrl + '/update-txn-date';
    return this.httpClient.put<BasicApiResponseModel<GenericDocARAPContainerModel>>(url, container, this.getHttpHeader(visa));
  }
}
